
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

export interface CandidatePickerOption {
  id: string;
  name: string;
  initials: string;
  color: string;
}

// Shared candidate/leader picker for the team reports. `selected` is a single id for
// single-select pickers, or an array of active ids for multi-toggle pickers. The parent
// owns the selection: clicking a chip emits `select` with its id.
@Component
export default class CandidatePicker extends Vue {
  @Prop({ required: true }) readonly options!: CandidatePickerOption[];
  @Prop({ default: null }) readonly selected!: string | string[] | null;

  isActive(id: string): boolean {
    return Array.isArray(this.selected) ? this.selected.includes(id) : this.selected === id;
  }
}
